import React from "react";
import { Column } from "@amzn/meridian";
import { useAppSelector } from "src/store/store";
import QuestionDisplayCard from "./questionDisplayCard";
import ObjectGroupCard from "./ObjectGroupCard";
import { Question } from "src/data/types";
import { getObjectInstanceDetails } from "src/components/pages/inspection/utils";

type QuestionsListProps = {
  processedQuestions: {
    groups: { [objectType: string]: Question[] };
    individuals: Question[];
  };
  onQuestionSelect?: (question: Question) => void;
  onObjectGroupSelect?: (objectType: string, questions: Question[]) => void;
};

const QuestionsList = ({ 
  processedQuestions,
  onQuestionSelect, 
  onObjectGroupSelect
}: QuestionsListProps) => {
  const { inspectionResults } = useAppSelector((state) => state.inspectionResults);

  return (
    <Column spacing="300">
      {/* Object Groups */}
      {Object.entries(processedQuestions.groups).map(([objectType, groupQuestions]) => {
        const instanceDetails = getObjectInstanceDetails(objectType, groupQuestions, inspectionResults as any);
        return (
          <ObjectGroupCard
            key={objectType}
            objectType={objectType}
            questions={groupQuestions}
            completedInstanceCount={instanceDetails.instanceCount}
            onSelect={onObjectGroupSelect || (() => {})}
          />
        );
      })}

      {/* Individual Questions */}
      {processedQuestions.individuals.map((question, idx) => {
        const result = inspectionResults.find(r => r.questionId === question.questionId);
        return (
          <QuestionDisplayCard
            key={question.questionId}
            question={question}
            questionOrder={idx + 1}
            onSelect={onQuestionSelect}
            result={result}
          />
        );
      })}
    </Column>
  );
};

export default QuestionsList;
